// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Show less`
};

const de_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Weniger anzeigen`
};

const es_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar menos`
};

const fr_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Afficher moins`
};

const fi_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Näytä vähemmän`
};

const ja_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `表示を減らす`
};

const nl_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Toon minder`
};

const pt_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar menos`
};

const ro_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Afișează mai puțin`
};

const th_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `แสดงน้อยลง`
};

const ur_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `کم دکھائیں`
};

const zh_hant1_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `顯示更少`
};

const da_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Vis mindre`
};

const it_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra di meno`
};

const vn_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Hiển thị ít hơn`
};

const ko_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `간단히 보기`
};

const tr_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Daha az göster`
};

const lv_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Rādīt mazāk`
};

const ar_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `عرض أقل`
};

const bs_widget_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Prikaži manje`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_show_less = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_show_less(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_show_less", locale)
	if (locale === "en") return en_widget_show_less(inputs)
	if (locale === "de") return de_widget_show_less(inputs)
	if (locale === "es") return es_widget_show_less(inputs)
	if (locale === "fr") return fr_widget_show_less(inputs)
	if (locale === "fi") return fi_widget_show_less(inputs)
	if (locale === "ja") return ja_widget_show_less(inputs)
	if (locale === "nl") return nl_widget_show_less(inputs)
	if (locale === "pt") return pt_widget_show_less(inputs)
	if (locale === "ro") return ro_widget_show_less(inputs)
	if (locale === "th") return th_widget_show_less(inputs)
	if (locale === "ur") return ur_widget_show_less(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_show_less(inputs)
	if (locale === "da") return da_widget_show_less(inputs)
	if (locale === "it") return it_widget_show_less(inputs)
	if (locale === "vn") return vn_widget_show_less(inputs)
	if (locale === "ko") return ko_widget_show_less(inputs)
	if (locale === "tr") return tr_widget_show_less(inputs)
	if (locale === "lv") return lv_widget_show_less(inputs)
	if (locale === "ar") return ar_widget_show_less(inputs)
	if (locale === "bs") return bs_widget_show_less(inputs)
	return "widget_show_less"
};